<template>
    <div class="statistics_box animate__animated animate__fadeIn">
        <div class="statistics">
            <div class="box_top" style="justify-content: center;">
                <div class="top_item">
                    <div class="item_title">项目总人数</div>
                    <div class="item_cont">
                        <img src="../../../assets/img/personnel_count.png" />
                        <div class="count">
                            <span>{{ totalCount.count }}</span>
                            人
                        </div>
                    </div>
                </div>
                <div class="top_item">
                    <div class="item_title">在岗</div>
                    <div class="item_cont">
                        <img src="../../../assets/img/departure_count.png" />
                        <div class="count">
                            <span>{{ totalCount.departureCount }}</span>
                            人
                        </div>
                    </div>
                </div>
                <div class="top_item">
                    <div class="item_title">今日考勤</div>
                    <div class="item_cont">
                        <img src="../../../assets/img/personnel_count.png" />
                        <div class="count">
                            <span>{{ totalCount.signCount }}</span>
                            人
                        </div>
                    </div>
                </div>
                <div class="top_item">
                    <div class="item_title">场内人数</div>
                    <div class="item_cont">
                        <img src="../../../assets/img/personnel_count.png" />
                        <div class="count">
                            <span>{{ totalCount.insideCount }}</span>
                            人
                        </div>
                    </div>
                </div>
                <div class="top_item">
                    <div class="item_title">考勤率</div>
                    <div class="item_cont">
                        <img src="../../../assets/img/personnel_attr.png" />
                        <div class="count">
                            <span>{{ totalCount.signRate }}</span>
                            %
                        </div>
                    </div>
                </div>
            </div>
            <div class="box_center">
                <div class="title_box">
                    <div class="chart_title">{{ showMonth }}月考勤统计图</div>
                    <div class="month_search">
                        <div class="line_input">
                            <div class="input_title">选择月份</div>
                            <el-date-picker size="small" v-model="searchMonth" type="month" value-format="yyyy-MM"
                                placeholder="选择年月"></el-date-picker>
                        </div>
                        <div class="search-btn" @click="fnGetMonthCount"><span>查看</span></div>
                    </div>
                </div>
                <div class="chart_box">
                    <div class="per-chart" ref="perChart"></div>
                </div>
            </div>
            <div class="box_bottom">
                <div class="team_position_box">
                    <div class="title_box">
                        <div class="chart_title">班组/工种统计</div>
                        <div class="date_search">
                            <div v-if="selectType == 0" @click="fnInitPositionChart" class="chart_change">切换工种</div>
                            <div v-if="selectType == 1" @click="fnInitTeamChart" class="chart_change">切换班组</div>
                            <div class="line_input">
                                <div class="input_title">选择日期</div>
                                <el-date-picker size="small" v-model="searchDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期"></el-date-picker>
                            </div>
                            <div class="search-btn" @click="fnChangeTeamPosition"><span>查看</span></div>
                        </div>
                    </div>
                    <div class="attr-chart" ref="attrChart"></div>
                </div>
                <div class="age_box">
                    <div class="chart_title">年龄分布统计</div>
                    <div class="chart_box">
                        <div class="age_chart" ref="ageChart"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import echarts from 'echarts';
    import APP from '@/utils/base';
    export default {
        data() {
            return {
                totalCount: {
                    // 人员统计
                    count: 0,
                    departureCount: 0,
                    signCount: 0,
                    signRate: 0,
                    insideCount: 0
                },
                searchMonth: '',
                showMonth: '',
                perChart: null,
                monthData: [],
                monthCount: [],
                selectType: 1, // 选择班组/工种
                searchDate: '', // 查询班组工种 -> 选择日期
                attrChart: null, // 班组/工种统计折线图
                teamData: [], // 班组 -> 班组统计
                teamDataLine: [], // 班组半透明柱状图总人数 -> 班组统计
                teamDataBar: [], // 班组实心柱状图打卡人数 -> 班组统计
                teamDataRate: [], // 班组折线图打卡率 -> 班组统计
                positionData: [], // 工种 -> 工种统计
                positionDataLine: [], // 工种半透明柱状图总人数 -> 工种统计
                positionDataBar: [], // 工种实心柱状图打卡人数 -> 工种统计
                positionDataRate: [], // 工种折线图打卡率 -> 工种统计
                ageChart: null, // 年龄分布饼状图
                ageData: [] // 年龄分布图
            };
        },
        mounted() {
            this.fnInit();
        },
        methods: {
            fnInit() {
                // 获取统计总人数/考勤人数数据
                this.fnGetPersonCount();
                // 获取当月每天人数统计
                this.fnGetMonthCount();
                // 获取班组/工种数据
                this.fnGetTeamPosition();
                // 获取年龄分布数据
                this.fnGetAge();
            },
            // 获取项目人员统计数据
            fnGetPersonCount() {
                request({
                        url: 'attendance/getTodayCount',
                        method: 'GET'
                    })
                    .then(res => {
                        let _count = res.data.count;
                        let _departureCount = res.data.departureCount
                        let _signCount = res.data.signCount;
                        let _signRate = _departureCount > 0 ? parseFloat(_signCount / _departureCount).toFixed(4) *
                            100 : 0;
                        this.totalCount.count = _count;
                        this.totalCount.departureCount = _departureCount;
                        this.totalCount.insideCount = res.data.insideCount;
                        this.totalCount.signCount = _signCount;
                        this.totalCount.signRate = parseFloat(_signRate).toFixed(2);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            // 获取当前日期
            fnGetDateFormat() {
                let _myDate = new Date();
                let _year = _myDate.getFullYear();
                let _month = APP.fnAddZero_public(_myDate.getMonth() + 1);
                let _day = APP.fnAddZero_public(_myDate.getDate());
                this.searchMonth = _year + '-' + _month;
            },
            // 获取当月每天人数统计
            fnGetMonthCount() {
                if (!this.searchMonth) {
                    this.fnGetDateFormat();
                }
                let _myDate = new Date(this.searchMonth);
                _myDate.setMonth(_myDate.getMonth() + 1);
                _myDate.setDate(0);
                request({
                        url: 'attendance/getMonthCount',
                        method: 'GET',
                        params: {
                            startDate: this.searchMonth + '-01',
                            endDate: this.searchMonth + '-' + _myDate.getDate()
                        }
                    })
                    .then(res => {
                        let _data = res.data;
                        let _name = [];
                        let _value = [];
                        for (let i in _data) {
                            _name.push(i);
                            _value.push(_data[i]);
                        }
                        this.monthCount = _value;
                        this.monthData = _name;
                        this.showMonth = this.searchMonth;
                        this.fnInitMonth();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnInitMonth() {
                let _option = {
                    title: {
                        text: '考勤统计',
                        x: 'center',
                        y: 0,
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 16,
                            fontWeight: 'normal'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        axisPointer: {
                            type: 'shadow',
                            label: {
                                show: true,
                                backgroundColor: '#7B7DDC'
                            }
                        }
                    },
                    grid: {
                        x: '10%',
                        width: '90%',
                        left: '5%',
                        y: '20%',
                        containLabel: true
                    },
                    xAxis: {
                        data: this.monthData,
                        axisLine: {
                            lineStyle: {
                                color: '#B4B4B4'
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: [{
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#B4B4B4'
                            }
                        },
                        axisLabel: {
                            formatter: '{value}'
                        }
                    }],
                    series: [{
                        name: '考勤人数',
                        type: 'line',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: '#F02FC2'
                            }
                        },
                        data: this.monthCount
                    }]
                };
                this.perChart = echarts.init(this.$refs.perChart);
                this.perChart.setOption(_option);
            },
            // 查看其他日期的班组工种打卡
            fnChangeTeamPosition() {
                this.selectType = 0;
                request({
                        url: 'personnel/getTeamPersonnel',
                        method: 'GET',
                        params: {
                            date: this.searchDate
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            if (res.data.team) {
                                let _teamData = res.data.team;
                                this.teamData = [];
                                this.teamDataLine = [];
                                this.teamDataBar = [];
                                this.teamDataRate = [];
                                for (let _key in _teamData) {
                                    this.teamData.push(_key);
                                    this.teamDataLine.push(_teamData[_key]['sum']);
                                    let _todayTeam = _teamData[_key]['today'] ? _teamData[_key]['today'] : 0;
                                    this.teamDataBar.push(_todayTeam);

                                    let _rate = _todayTeam / _teamData[_key]['sum'];
                                    _rate = _rate ? parseInt(_rate * 100) : 0;
                                    this.teamDataRate.push(_rate == _rate ? _rate : 0);
                                }
                            }
                            if (res.data.work) {
                                let _positionData = res.data.work;
                                this.positionData = [];
                                this.positionDataLine = [];
                                this.positionDataBar = [];
                                this.positionDataRate = [];
                                for (let _key in _positionData) {
                                    this.positionData.push(_key);
                                    this.positionDataLine.push(_positionData[_key]['sum']);
                                    let _todayPosition = _positionData[_key]['today'] ? _positionData[_key][
                                        'today'
                                    ] : 0;
                                    this.positionDataBar.push(_todayPosition);

                                    let _rate = _todayPosition / _positionData[_key]['sum'];
                                    _rate = _rate ? parseInt(_rate * 100) : 0;
                                    this.positionDataRate.push(_rate == _rate ? _rate : 0);
                                }
                            }
                            this.fnInitTeamChart();
                        }
                    })
                    .catch(err => {
                        // this.$message.error(err.data);
                    });
            },
            // 获取班组/工种统计
            fnGetTeamPosition() {
                request({
                        url: 'personnel/getTeamPersonnel',
                        method: 'GET'
                    })
                    .then(res => {
                        if (res.data) {
                            if (res.data.team) {
                                let _teamData = res.data.team;
                                this.teamData = [];
                                this.teamDataLine = [];
                                this.teamDataBar = [];
                                this.teamDataRate = [];
                                for (let _key in _teamData) {
                                    this.teamData.push(_key);
                                    this.teamDataLine.push(_teamData[_key]['sum']);
                                    let _todayTeam = _teamData[_key]['today'] ? _teamData[_key]['today'] : 0;
                                    this.teamDataBar.push(_todayTeam);

                                    let _rate = _todayTeam / _teamData[_key]['sum'];
                                    _rate = _rate ? parseInt(_rate * 100) : 0;
                                    this.teamDataRate.push(_rate == _rate ? _rate : 0);
                                }
                            }
                            if (res.data.work) {
                                let _positionData = res.data.work;
                                this.positionData = [];
                                this.positionDataLine = [];
                                this.positionDataBar = [];
                                this.positionDataRate = [];
                                for (let _key in _positionData) {
                                    this.positionData.push(_key);
                                    this.positionDataLine.push(_positionData[_key]['sum']);
                                    let _todayPosition = _positionData[_key]['today'] ? _positionData[_key][
                                        'today'
                                    ] : 0;
                                    this.positionDataBar.push(_todayPosition);

                                    let _rate = _todayPosition / _positionData[_key]['sum'];
                                    _rate = _rate ? parseInt(_rate * 100) : 0;
                                    this.positionDataRate.push(_rate == _rate ? _rate : 0);
                                }
                            }
                            this.fnInitTeamChart();
                        }
                    })
                    .catch(err => {
                        // this.$message.error(err.data);
                    });
            },
            // 初始化班组统计图
            fnInitTeamChart() {
                this.selectType = 0;
                let _option = {
                    title: {
                        text: '班组统计',
                        x: 'center',
                        y: 0,
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 16,
                            fontWeight: 'normal'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        axisPointer: {
                            type: 'shadow',
                            label: {
                                show: true,
                                backgroundColor: '#7B7DDC'
                            }
                        }
                    },
                    legend: {
                        data: ['考勤人数', '总人数', '打卡率'],
                        textStyle: {
                            color: '#B4B4B4'
                        },
                        top: '10%'
                    },
                    grid: {
                        x: '12%',
                        width: '90%',
                        left: '5%',
                        y: '23%',
                        containLabel: true
                    },
                    xAxis: {
                        data: this.teamData,
                        axisLine: {
                            lineStyle: {
                                color: '#B4B4B4'
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: [{
                            splitLine: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#B4B4B4'
                                }
                            },
                            axisLabel: {
                                formatter: '{value}'
                            }
                        },
                        {
                            name: '打卡率(%)',
                            splitLine: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#B4B4B4'
                                }
                            },
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series: [{
                            name: '打卡率',
                            type: 'line',
                            smooth: true,
                            showAllSymbol: true,
                            symbol: 'emptyCircle',
                            symbolSize: 8,
                            yAxisIndex: 1,
                            itemStyle: {
                                normal: {
                                    color: '#F02FC2'
                                }
                            },
                            data: this.teamDataRate
                        },
                        {
                            name: '考勤人数',
                            type: 'bar',
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    barBorderTopRightRadius: 10,
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#956FD4'
                                    }, {
                                        offset: 1,
                                        color: '#3EACE5'
                                    }])
                                }
                            },
                            data: this.teamDataBar
                        },
                        {
                            name: '总人数',
                            type: 'bar',
                            barGap: '-100%',
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    barBorderRadius: 5,
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                            offset: 0,
                                            color: 'rgba(156,107,211,0.5)'
                                        },
                                        {
                                            offset: 0.2,
                                            color: 'rgba(156,107,211,0.3)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(156,107,211,0)'
                                        }
                                    ])
                                }
                            },
                            z: -12,
                            data: this.teamDataLine
                        }
                    ]
                };
                this.attrChart = echarts.init(this.$refs.attrChart);
                this.attrChart.setOption(_option);
            },
            // 初始化工种统计图
            fnInitPositionChart() {
                this.selectType = 1;
                let _options = {
                    title: {
                        text: '工种统计',
                        x: 'center',
                        y: 0,
                        textStyle: {
                            color: '#B4B4B4',
                            fontSize: 16,
                            fontWeight: 'normal'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        axisPointer: {
                            type: 'shadow',
                            label: {
                                show: true,
                                backgroundColor: '#7B7DDC'
                            }
                        }
                    },
                    legend: {
                        data: ['在场人数', '总人数', '打卡率'],
                        textStyle: {
                            color: '#B4B4B4'
                        },
                        top: '10%'
                    },
                    grid: {
                        x: '12%',
                        width: '90%',
                        left: '5%',
                        y: '23%',
                        containLabel: true
                    },
                    xAxis: {
                        data: this.positionData,
                        axisLine: {
                            lineStyle: {
                                color: '#B4B4B4'
                            }
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    yAxis: [{
                            splitLine: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#B4B4B4'
                                }
                            },
                            axisLabel: {
                                formatter: '{value}'
                            }
                        },
                        {
                            name: '打卡率(%)',
                            splitLine: {
                                show: false
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#B4B4B4'
                                }
                            },
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series: [{
                            name: '打卡率',
                            type: 'line',
                            smooth: true,
                            showAllSymbol: true,
                            symbol: 'emptyCircle',
                            symbolSize: 8,
                            yAxisIndex: 1,
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    color: '#F02FC2'
                                }
                            },
                            data: this.positionDataRate
                        },
                        {
                            name: '在场人数',
                            type: 'bar',
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    barBorderTopRightRadius: 10,
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#956FD4'
                                    }, {
                                        offset: 1,
                                        color: '#3EACE5'
                                    }])
                                }
                            },
                            data: this.positionDataBar
                        },
                        {
                            name: '总人数',
                            type: 'bar',
                            barGap: '-100%',
                            barWidth: 20,
                            itemStyle: {
                                normal: {
                                    barBorderRadius: 5,
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                            offset: 0,
                                            color: 'rgba(156,107,211,0.5)'
                                        },
                                        {
                                            offset: 0.2,
                                            color: 'rgba(156,107,211,0.3)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(156,107,211,0)'
                                        }
                                    ])
                                }
                            },
                            z: -12,
                            data: this.positionDataLine
                        }
                    ]
                };
                this.attrChart = echarts.init(this.$refs.attrChart);
                this.attrChart.setOption(_options);
            },
            // 获取年龄分布
            fnGetAge() {
                request({
                        url: '/personnel/getAgeStructure',
                        method: 'GET'
                    })
                    .then(res => {
                        if (res.data) {
                            let _data = res.data;
                            let _arr = [{
                                    value: _data['less_22'],
                                    name: '小于22岁'
                                },
                                {
                                    value: _data['22To25'],
                                    name: '22至25岁'
                                },
                                {
                                    value: _data['26To35'],
                                    name: '26至35岁'
                                },
                                {
                                    value: _data['36To45'],
                                    name: '36至45岁'
                                },
                                {
                                    value: _data['46To55'],
                                    name: '46至55岁'
                                },
                                {
                                    value: _data['56To65'],
                                    name: '56至65岁'
                                },
                                {
                                    value: _data['more_65'],
                                    name: '大于65岁'
                                },
                                {
                                    value: _data['other'],
                                    name: '未知'
                                }
                            ];
                            this.ageData = _arr;
                            this.fnInitAgeChart();
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 年龄分布统计
            fnInitAgeChart() {
                let _option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'horizontal',
                        top: '5%',
                        left: 'right',
                        width: '12%',
                        textStyle: {
                            color: '#ffffff'
                        },
                        data: [{
                                name: '小于22岁',
                                textStyle: {
                                    color: '#F368E0'
                                }
                            },
                            {
                                name: '22至25岁',
                                textStyle: {
                                    color: '#6CEEAF'
                                }
                            },
                            {
                                name: '26至35岁',
                                textStyle: {
                                    color: '#4D81F7'
                                }
                            },
                            {
                                name: '36至45岁',
                                textStyle: {
                                    color: '#FFCC3F'
                                }
                            },
                            {
                                name: '46至55岁',
                                textStyle: {
                                    color: '#9BF9FC'
                                }
                            },
                            {
                                name: '56至65岁',
                                textStyle: {
                                    color: '#FF6A72'
                                }
                            },
                            {
                                name: '大于65岁',
                                textStyle: {
                                    color: '#E67E23'
                                }
                            },
                            {
                                name: '未知',
                                textStyle: {
                                    color: '#8A8F97'
                                }
                            }
                        ]
                    },
                    color: ['#F368E0', '#6CEEAF', '#4D81F7', '#FFCC3F', '#9BF9FC', '#FF6A72', '#E67E23', '#8A8F97'],
                    series: [{
                        name: '年龄分布统计',
                        type: 'pie',
                        center: ['40%', '50%'],
                        radius: ['50%', '90%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '20',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.ageData
                    }]
                };
                this.ageChart = echarts.init(this.$refs.ageChart);
                this.ageChart.setOption(_option);
            }
        }
    };
</script>

<style scoped lang="scss">
    @import '~@/styles/mixin.scss';

    .statistics_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .statistics {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: hidden;
        }
    }

    .box_top {

        width: 100%;
        height: 218px;
        // margin: 0 120px;
        padding: 48px 0 30px;
        @include flex-box(space-between, center);

        .top_item {
            width: 300px;
            height: 140px;
            margin: 0 30px;
            border: 1px solid #ffffff;
            border-radius: 8px;
            @include flex-box(flex-start, center, column);

            .item_title {
                width: 300px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                font-size: 30px;
                color: #ffffff;
            }

            .item_cont {
                width: 300px;
                height: 340px;
                // margin: 0 50px;
                @include flex-box(center, center);

                img {
                    width: 60px;
                    height: 60px;
                }

                .count {
                    margin-left: 50px;
                    font-size: 22px;

                    span {
                        font-size: 42px;
                        color: #9cf8fb;
                    }
                }
            }
        }
    }

    .box_center {
        width: 1880px;
        height: 320px;
        margin: 0 20px;
        overflow: hidden;

        .title_box {
            width: 1880px;
            height: 40px;
            @include flex-box(space-between, center);

            .chart_title {
                width: 240px;
                height: 40px;
                line-height: 40px;
                font-size: 22px;
                text-align: center;
            }

            .month_search {
                width: 400px;
                height: 40px;
                @include flex-box(flex-start, center);

                .line_input {
                    min-width: 280px;
                    height: 30px;
                    margin-right: 10px;
                    border-top-right-radius: 1px;
                    border-bottom-right-radius: 1px;
                    background-color: rgba(49, 88, 128, 0.4);
                    @include flex-box(flex-start, center);

                    .input_title {
                        width: 70px;
                        height: 30px;
                        font-size: 14px;
                        color: #9bf9fc;
                        border-radius: 2px;
                        background-color: rgba(155, 249, 252, 0.1);
                        @include flex-box(center, center);
                    }

                    .input_box {
                        width: 210px;
                        height: 30px;
                        line-height: 30px;
                        padding-left: 15px;
                        color: rgba(77, 180, 244, 0.7);
                        font-size: 12px;
                        border-radius: 2px;
                        outline: none;
                        background: transparent;
                        border: none;

                        &::-webkit-input-placeholder {
                            color: rgba(77, 180, 244, 0.7);
                        }

                        &::-moz-placeholder {
                            /* Mozilla Firefox 19+ */
                            color: rgba(77, 180, 244, 0.7);
                        }

                        &:-moz-placeholder {
                            /* Mozilla Firefox 4 to 18 */
                            color: rgba(77, 180, 244, 0.7);
                        }

                        &:-ms-input-placeholder {
                            /* Internet Explorer 10-11 */
                            color: rgba(77, 180, 244, 0.7);
                        }
                    }
                }

                >>>.el-input__inner {
                    width: 211px;
                    height: 30px;
                    border-radius: 2px;
                    border: none;
                    color: rgba(77, 180, 244, 0.7);
                    background: transparent;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }

                >>>.el-input__icon {
                    color: rgba(77, 180, 244, 0.7);
                }
            }
        }

        .chart_box {
            width: 1880px;
            height: 280px;

            .per-chart {
                height: 320px;
            }
        }
    }

    .box_bottom {
        width: 1880px;
        height: 320px;
        margin: 0 20px;
        overflow: hidden;
        @include flex-box();

        .team_position_box {
            width: 1440px;
            height: 320px;

            .title_box {
                width: 1440px;
                height: 40px;
                @include flex-box(space-between, center);

                .chart_title {
                    width: 180px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 22px;
                    text-align: center;
                }

                .date_search {
                    width: 500px;
                    height: 40px;
                    @include flex-box(flex-start, center);

                    .chart_change {
                        width: 100px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        text-decoration: underline;
                        color: #007aff;
                        font-size: 18px;
                        cursor: pointer;
                    }

                    .line_input {
                        min-width: 280px;
                        height: 30px;
                        margin-right: 10px;
                        border-top-right-radius: 1px;
                        border-bottom-right-radius: 1px;
                        background-color: rgba(49, 88, 128, 0.4);
                        @include flex-box(flex-start, center);

                        .input_title {
                            width: 70px;
                            height: 30px;
                            font-size: 14px;
                            color: #9bf9fc;
                            border-radius: 2px;
                            background-color: rgba(155, 249, 252, 0.1);
                            @include flex-box(center, center);
                        }

                        .input_box {
                            width: 210px;
                            height: 30px;
                            line-height: 30px;
                            padding-left: 15px;
                            color: rgba(77, 180, 244, 0.7);
                            font-size: 12px;
                            border-radius: 2px;
                            outline: none;
                            background: transparent;
                            border: none;

                            &::-webkit-input-placeholder {
                                color: rgba(77, 180, 244, 0.7);
                            }

                            &::-moz-placeholder {
                                /* Mozilla Firefox 19+ */
                                color: rgba(77, 180, 244, 0.7);
                            }

                            &:-moz-placeholder {
                                /* Mozilla Firefox 4 to 18 */
                                color: rgba(77, 180, 244, 0.7);
                            }

                            &:-ms-input-placeholder {
                                /* Internet Explorer 10-11 */
                                color: rgba(77, 180, 244, 0.7);
                            }
                        }
                    }

                    >>>.el-input__inner {
                        width: 211px;
                        height: 30px;
                        border-radius: 2px;
                        border: none;
                        color: rgba(77, 180, 244, 0.7);
                        background: transparent;

                        &::-webkit-input-placeholder {
                            color: rgba(77, 180, 244, 0.7);
                        }

                        &::-moz-placeholder {
                            /* Mozilla Firefox 19+ */
                            color: rgba(77, 180, 244, 0.7);
                        }

                        &:-moz-placeholder {
                            /* Mozilla Firefox 4 to 18 */
                            color: rgba(77, 180, 244, 0.7);
                        }

                        &:-ms-input-placeholder {
                            /* Internet Explorer 10-11 */
                            color: rgba(77, 180, 244, 0.7);
                        }
                    }

                    >>>.el-input__icon {
                        color: rgba(77, 180, 244, 0.7);
                    }
                }
            }

            .attr-chart {
                height: 320px;
            }
        }

        .age_box {
            width: 440px;
            height: 320px;
            @include flex-box(flex-start, flex-start, column);

            .chart_title {
                width: 180px;
                height: 40px;
                line-height: 40px;
                font-size: 22px;
                text-align: center;
            }

            .chart_box {
                width: 440px;
                height: 280px;

                .age_chart {
                    height: 280px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/PersonnelStatistics/personnelStatisticsDefault/personnelStatistics.vue